// extracted by mini-css-extract-plugin
export default {"scrollbarOverlay":"MyProjectPage_scrollbarOverlay__d8LqE"};